import { Content } from '../../types';

export const huaHinContent: Content = {
  title: 'הואה הין - חופשה רגועה על חופי מפרץ תאילנד',
  imageUrl: '/images/thailand/hua-hin/hua-hin-wide.jpeg',
  introduction:
    'הואה הין, הינה אחת מערי הנופש המרכזיות והמתפתחות בתאילנד והשקטה והנינוחה שמביניהן, שוכנת בצידו המערבי של מפרץ תאילנד, במחוז Prachuap Khiri Khan, במרחק של כ-2.5 שעות נסיעה דרומית-מערבית לבנגקוק. ייחודיותה של העיר באה לידי ביטוי בכך שהינה משלבת בין קסם מקומי לאווירה מערבית מתוחזקת ונקייה ולמרות היותה יעד מוכר ופופולרי, שומרת הואה הין על תחושת שקט ורוגע, המבדילה אותה מיעדי חוף אחרים בתאילנד. העיר מושכת אליה משפחות, זוגות, גמלאים ואפילו את בני משפחת המלוכה התאילנדית, ומציעה מגוון חוויות רבות למטיילים - החל מחופים יפים ועד תרבות אותנטית.',
  sections: [
    {
      title: 'מזג אוויר בהואה הין',
      type: 'sub-headers',
      description:
        'הואה הין, כמו יתר אזור החוף המערבי של תאילנד, נהנית ממזג אוויר טרופי חם ולח במשך רוב ימות השנה. עם זאת, ישנם הבדלים בין העונות, ויש לקחת אותם בחשבון כשמתכננים את הביקור.',
      content: [
        {
          subtitle: 'העונה היבשה (נובמבר עד פברואר)',
          text: 'זהו הזמן האידיאלי לביקור בהואה הין, שכן מזג האוויר קריר ונעים יותר. הטמפרטורות נעות בין 24°C ל-30°C ויש מעט מאוד גשם.',
        },
        {
          subtitle: 'העונה החמה (מרץ עד יוני)',
          text: 'בעונה זו חם מאוד והטמפרטורות יכולות להגיע עד 35°C ואף יותר, במיוחד במאי וביוני. הלחות גבוהה מאוד, כך שחשוב לשתות הרבה מים ולהימנע מחשיפה ממושכת לשמש.',
        },
        {
          subtitle: 'העונה הרטובה (יולי עד אוקטובר)',
          text: 'בעונה זו ישנם גשמים רבים, אך הם נוטים להיות קצרים ולא להימשך לאורך כל היום. עם זאת, ייתכן כי חופי הים יהיו פחות מזמינים ופעילויות חוץ עשויות להיות מוגבלות.',
        },
      ],
    },
    {
      title: 'אזורים מומלצים ללינה בהואה הין',
      type: 'sub-headers',
      description:
        'הואה הין מציעה מגוון אפשרויות לינה המתאימות לכל סוגי המטיילים, ממלונות יוקרה ועד אכסניות פשוטות יותר. הנה כמה מהאזורים המומלצים:',
      content: [
        {
          subtitle: 'מרכז העיר (Hua Hin Town)',
          text: 'אם הינכם מעוניינים בנוחות ובקרבה לאטרקציות, זהו האזור המושלם. זוהי רצועה ארוכה, המכילה שפע של מסעדות, שווקים ומרכזי קניות, כמו גם מגוון רחב של בתי מלון ואכסניות, במגוון מחירים. באזור זה נכללת אף העיר העתיקה של הואה הין - אזור עם מבני עץ היסטוריים המאכלסים מסעדות, חנויות ובתי מלון קטנים.<br/><strong>מלונות מומלצים:</strong> Putahracsa Hua Hin, Hilton Hua Hin Resort & Spa, The Peri Hotel Hua Hin, Maven Stylish Hotel, VISA Hotel',
        },
        {
          subtitle: 'החוף הדרומי (Khao Takiab)',
          text: "אזור שקט יותר דרומית לעיר, אך עדיין קרוב לחוף. יש בו מספר מלונות בוטיק, כמו גם אתרי נופש עם נופים מדהימים של הים וההרים.<br/><strong>מלונות מומלצים:</strong> Let's Sea Hua Hin Al Fresco Resort, The Rock Hua Hin Resort",
        },
        {
          subtitle: 'Cha-Am',
          text: 'עיירה צמודה להואה הין, המציעה חופי ים רגועים ומלונות נופש למשפחות. זהו אזור מצוין עבור המחפשים שקט יחסי, אך עדיין להימצא במרחק קצר מהעיר.<br/><strong>מלונות מומלצים:</strong> SO Sofitel Hua Hin, Veranda Resort & Villas Hua Hin Cha Am',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית והשכרת רכבים',
      type: 'sub-headers',
      description:
        'בתוך העיר ניתן לנוע בקלות באמצעות טוק-טוקים או מוניות מקומיות במחיר נוח. להשגת גמישות בטיולים מחוץ לעיר, מומלץ מאוד לשכור רכב או קטנוע, אך יש לוודא כי ברשותכם רישיון מתאים וביטוח, שניהם בתוקף.',
      content: [
        {
          subtitle: 'תחבורה ציבורית',
          text: 'האזור מציע תחבורה ציבורית מצויינת ובכלל זה, מיניבוסים (Songthaew) המחברים בין המקומות השונים בעיר וכן מוניות.',
        },
        {
          subtitle: 'השכרת רכבים',
          text: 'ישנם מספר סוכנויות להשכרת רכבים בעיר, כך שניתן ואף מומלץ לשכור רכב במידה וברצונכם לטייל באזור באופן עצמאית. גם אופניים ומכוניות חשמליות זמינים להשכרה.',
        },
        {
          subtitle: 'אופניים ואופנועים',
          text: 'אחת הדרכים הפופולריות ביותר להסתובב בעיר הינה באמצעות אופניים או אופנועים. רבים מהמלונות מציעים השכרת אופניים.',
        },
      ],
      displayRentalAffiliate: true,
    },
    {
      title: 'דרכי הגעה להואה הין',
      type: 'sub-headers',
      description:
        'הואה הין ממוקמת במרחק של כ - 200 קילומטרים דרומית לבנגקוק וההגעה אליה נוחה, במגוון דרכים.',
      content: [
        {
          subtitle: 'רכבים פרטיים',
          text: 'הדרך המהירה ביותר להגיע להואה הין מבנגקוק הינה באמצעות רכב פרטי. הנסיעה לוקחת כ-3 שעות.',
        },
        {
          subtitle: 'אוטובוסים',
          text: 'קיימת תחבורה ציבורית מעולה מבנגקוק להואה הין, באמצעות אוטובוסים יומיים שמוצעים בגרסאות שונות (רגילות, אקספרס ומפוארות). הנסיעה לוקחת כ-3-4 שעות.',
        },
        {
          subtitle: 'רכבות',
          text: 'רכבות יוצאות מידי יום מבנגקוק להואה הין ומציעות חוויית נסיעה ייחודית. נסיעה ברכבת נמשכת בין 4 ל - 5 שעות.',
        },
        {
          subtitle: 'טיסה',
          text: 'ניתן להגיע להואה הין באמצעות טיסות מקומיות. ישנו שדה תעופה קטן בהואה הין (Hua Hin Airport) המשרת טיסות פנימיות ממספר ערים בתאילנד.',
        },
      ],
    },
    {
      title: 'חופים מרכזיים בהואה הין',
      type: 'sub-headers',
      description:
        'הואה הין מתהדרת באחת מרצועות החופים הנוחים והנגישים ביותר בתאילנד, במיוחד עבור משפחות ומטיילים המעדיפים אווירה רגועה ובטוחה. החופים כאן אינם פרועים כמו אלו שבאיים, אך בהחלט מספקים חוויית חוף נעימה, נקייה ועם טיילות מסודרות ומתקנים לתיירים.',
      content: [
        {
          subtitle: 'חוף הואה הין המרכזי (Hua Hin Beach)',
          text: 'זהו החוף המפורסם ביותר בעיר, המשתרע לאורך של כ -7 ק"מ, מצפון למרכז העיר ועד אזור קאו טאקיאב (Khao Takiab) שבדרום העיר. החוף רחב ושטוח, עם חול בהיר ומים רדודים - מה שהופך אותו לאידיאלי למשפחות עם ילדים. לאורך החוף תמצאו סוסים לרכיבה, כסאות נוח להשכרה, דוכנים קטנים של שתייה וקוקוסים ואף גישה נוחה מהמלונות הממוקמים בקרבתו.',
        },
        {
          subtitle: 'חוף קאו טאקיאב (Khao Takiab Beach)',
          text: 'מדרום לחוף המרכזי, שוכן חוף שקט יותר הנמצא למרגלות הר קאו טאקיאב. זהו אזור מצוין לרחצה, טיולים רגליים, צפייה בנזירים מקומיים המטפסים להר בשעות הבוקר המוקדמות ואף תצפית על הקופים הרבים החיים באזור. לאורך החוף תמצאו אף מספר מסעדות מקומיות עם נוף פתוח לים. בקרבת החוף, ממוקם כפר הדייגים העתיק - מקום קסום המשמר את ההיסטוריה של העיר, עם אפשרות ליהנות ממסעדות דגים טריים.',
        },
        {
          subtitle: 'חוף סואן סון פראדיפאט (Suan Son Pradipat Beach)',
          text: 'חוף פחות מוכר אך מאוד אהוב על המקומיים. שוכן מדרום לאזור קאו טאקיאב, בתוך שטח של הצבא המלכותי התאילנדי, אך פתוח לקהל. מדובר בחוף שקט עם עצי אורן היוצרים צל טבעי, מתאים לפיקניקים או למבקשים לברוח מהמוני התיירים.',
        },
        {
          subtitle: 'חוף קאו טאו (Khao Tao Beach)',
          text: 'ממוקם כ-13 ק"מ מדרום להואה הין, זהו חוף קטן יותר אך ציורי, עם סלעים טבעיים ונוף גבעות. בקצה החוף שוכן כפר דייגים מסורתי ונעים לסיור ובסמוך אליו, אגם מים מתוקים - מראה ייחודי באזור.',
        },
      ],
    },
    {
      title: 'שווקים בהואה הין',
      type: 'sub-headers',
      description:
        'הואה הין מציעה שווקים ססגוניים, תוססים ומגוונים, ההופכים את חוויית הקנייה לא רק לזולה ומשתלמת - אלא גם לאטרקציה תרבותית של ממש. כאן תוכלו למצוא בגדים, מתנות, עבודות יד, פירות טרופיים, מאכלי רחוב תאיים ועוד - באווירה חמה ומקומית במיוחד.',
      content: [
        {
          subtitle: 'שוק הלילה של הואה הין (Hua Hin Night Market)',
          text: "שוק הלילה הקלאסי והפופולרי ביותר בעיר. נמצא בלב המרכז ההיסטורי של הואה הין, ברחוב Dechanuchit ונפתח מדי ערב משעות אחר הצהריים ועד 23:00. כאן תמצאו כל מה שתייר יכול לבקש - מדוכני בגדים, מזכרות, נעלי גומי ועד דוכני אוכל רחוב עם פירות ים טריים, פנקייקים - בננה רוט'י, מיצים טריים וצלחות פאד תאי. מומלץ להגיע מוקדם כדי להימנע מהעומס.<br/><strong>שעות פתיחה:</strong> כל ערב החל מ - 17:00 ועד 23:00<br/><strong>מיקום:</strong> רחוב Dechanuchit, בקרבת תחנת הרכבת",
        },
        {
          subtitle: 'Cicada Market - שוק אומנות ותרבות',
          text: 'שוק פתוח הפועל בסופי שבוע בלבד, עם דגש על יצירה, אמנות, בגדי מעצבים, קוסמטיקה טבעית ופריטי דקורציה מקוריים. האווירה בשוק רגועה יותר והמוזיקה החיה הופכת את החוויה לנעימה במיוחד. בנוסף לשוק, ישנו אזור אוכל עשיר וטעים מאוד, עם מגוון דוכני גורמה. מתאים מאוד לזוגות ולמשפחות.<br/><strong>שעות פתיחה:</strong> ימים שישי עד ראשון, 17:00 עד 23:00<br/><strong>מיקום:</strong> רחוב Khao Takiab, בסמוך לפארק Suan Sri<br/><strong>טיפ:</strong> המקום די עמוס - מומלץ להגיע עד 18:30 כדי למצוא מקום ישיבה וליהנות מההופעות.',
        },
        {
          subtitle: 'Tamarind Market - שוק אוכל שיקי',
          text: 'צמוד ל - Cicada Market, אך מתמקד באוכל בלבד - דוכני שפים, קינוחים, שייקים, בירות קרות ומוזיקה חיה בכל ערב. מושך קהל צעיר ותיירים מערביים, אך גם לא מעט תאילנדים מקומיים. מקום מושלם לארוחת ערב קלה באווירה פתוחה.<br/><strong>שעות פתיחה:</strong> ימים חמישי עד ראשון, 17:00 עד 23:00<br/><strong>מיקום:</strong> סמוך ל - Cicada Market',
        },
        {
          subtitle: 'Chat Chai Day Market - שוק מקומי אותנטי',
          text: 'שוק יומי מקורה הפועל בעיקר בשעות הבוקר ומציע ירקות, פירות, תבלינים, בשר, דגים, ביצים, מתוקים תאיים ועוד - בסטייל אותנטי מאוד. מתאים בעיקר למעוניינים להכיר את התרבות המקומית ולאו דווקא לקנות מזכרות. הביקור במקום מהווה גם חוויה קולינרית מסקרנת.<br/><strong>שעות פתיחה:</strong> כל יום, החל מ - 06:00 ועד 13:00<br/><strong>מיקום:</strong> רחוב Petchkasem, בסמוך מרכז העיר',
        },
      ],
    },

    {
      title: 'קניות ומרכזי קניות בהואה הין',
      type: 'sub-headers',
      description:
        'לצד השווקים המקומיים, הואה הין מציעה אף מרכזי קניות מודרניים ונוחים, בהם תוכלו ליהנות מקניות באווירה ממוזגת המהווה חוויית בילוי לכל המשפחה, רשתות בינלאומיות, מסעדות ובתי קפה מערביים ולעיתים אף פעילויות לילדים.',
      content: [
        {
          subtitle: 'BluPort Hua Hin Resort Mall',
          text: 'הקניון המרכזי והמפואר ביותר בעיר, נפתח ב-2016 ומשלב בין אווירה של ריזורט יוקרתי למרכז קניות מודרני. תמצאו כאן רשתות מוכרות כמו H&M, Uniqlo, סופרמרקט Gourmet Market, מסעדות מערביות, מתחם אוכל תאילנדי, בית קולנוע, מתחם משחקים לילדים, דוכני מתנות וקוסמטיקה. מתאים במיוחד לימי גשם או להפוגה מהחום.<br/><strong>שעות פתיחה:</strong> בכל יום, החל מ - 10:00 ועד 21:00<br/><strong>מיקום:</strong> Petchkasem Road, בסמוך למלון InterContinental<br/><strong>טיפ:</strong> בקומה התחתונה תמצאו דוכני אוכל מקומי במחירים זולים יחסית.',
        },
        {
          subtitle: 'Market Village Hua Hin',
          text: 'מרכז קניות ותיק וגדול, המתאים מאוד למשפחות. יש בו חנויות בגדים, רשתות אלקטרוניקה, חנות של B2S (מוצרי יצירה וספרים), מסעדות, בתי קפה, מתחם אוכל, קולנוע, סופרמרקט Tesco Lotus ואף מתחם משחקים לילדים. זהו מקום נוח לעצירה במהלך יום סיורים או לקניות "אמיתיות".<br/><strong>שעות פתיחה:</strong> בכל יום, החל מ - 10:00 ועד 21:00<br/><strong>מיקום:</strong> Petchkasem Road, בסמוך למרכז העיר',
        },
        {
          subtitle: 'Premium Outlet Cha - am',
          text: "מרכז הקניות Premium Outlet Cha-Am ממוקם צפונית להואה הין, בסמוך לעיר צ'ה-אם. זהו אאוטלט רחב ידיים עם מאות חנויות מותגים במחירים מוזלים של עד 70%. תמצאו כאן מותגים בינלאומיים כמו Nike, Adidas, Levi's, Lacoste ועוד, לצד מותגים תאיים. המקום מוצל ומרווח, מתאים למשפחות ויש גם בתי קפה ומסעדות קטנות לנוח בהן באמצע הקניות.<br/><strong>שעות פתיחה:</strong> בכל יום החל מ - 10:00 ועד 19:00<br/><strong>מיקום:</strong> סמוך לעיירה צ'ה אם, צפונית להואה הין",
        },
      ],
    },
    {
      title: 'פארקים, טבע וגנים בהואה הין',
      type: 'sub-headers',
      description:
        'מעבר לחופים ולשווקים, הואה הין מציעה שפע של אתרי טבע, גנים מטופחים ופארקים לאומיים, המשלבים נופים עוצרי נשימה, מפלים, מערות וסיורים בטבע. חלקם נמצאים בלב העיר ואחרים מחוץ לה, אך כולם שווים ביקור - במיוחד עבור מטיילים האוהבים טבע, הליכה רגלית, צילום ונופים ירוקים.',
      content: [
        {
          subtitle: 'Sam Roi Yot National Park (שמורת שלוש מאות הפסגות)',
          text: 'פארק לאומי מרשים במרחק כשעה נסיעה דרומית להואה הין, המשלב הרים קרסטיים, לגונות, חופים סודיים, מערות ומסלולי הליכה. האטרקציה המפורסמת ביותר בשמורה, הינה מערת פראיה נאקון (Phraya Nakhon Cave), בה מסתתר ביתן מלכותי בתוך חלל ענק שאליו חודרות קרני שמש - מראה עוצר נשימה.<br/>הפארק גם כולל מסלולי הליכה קלים, תצפיות, חוף ים, תעלות שיט וסיורי טבע לצפייה בציפורים ובקופי לנגור.<br/>צפייה בעופות - הפארק מהווה מקום חשוב לצפייה בעופות, במיוחד עופות מים. ניתן לראות בו מיני ציפורים נדירות, כגון עופות חופי ודורסים.<br/>טיולים בסירות - ניתן לשכור סירות ולטייל לאורך חופי הפארק, מה שמספק הזדמנות מצוינת לראות את המגוון האקולוגי של האזור, כולל דולפינים ומיני בעלי חיים אחרים.<br/><strong>מרחק:</strong> כ-45 ק"מ דרומית להואה הין<br/><strong>טיפ:</strong> מומלץ להגיע מוקדם בבוקר למערת פראיה נאקון - העלייה מעט מאתגרת (כ-30 דקות הליכה).',
        },
        {
          subtitle: 'Pa La-U Waterfall (מפלי פא לא יו)',
          text: 'מפלים מרשימים בלב יער גשם, כשעה נסיעה מערבית להואה הין, בתוך שמורת הטבע הגדולה במדינה - שמורת Kaeng Krachan. זהו יעד טבעי נהדר לטיול יומי מחוץ לעיר. יש בו שביל מסודר לאורך 5 - 7 מפלסים של מפלים (השלבים הגבוהים יותר דורשים כושר גופני קל), עם בריכות מים טבעיות המתאימות לשחייה ומנוחה.<br/>צמחייה ובעלי חיים - במהלך ההליכה תוכל לראות צמחייה טרופית עשירה ובעלי חיים כגון קופים, ציפורים אקזוטיות וחיות אחרות.<br/><strong>טיפ:</strong> הביאו בגד ים ונעליים להליכה במים. המקום פחות מתוייר ומרגיש כמו טבע אמיתי.',
        },
        {
          subtitle: 'הפארק הלאומי Kaeng Krachan',
          text: "הפארק הלאומי Kaeng Krachan הינו פארק הטבע הגדול ביותר בתאילנד וכולל מגוון של מערכות אקולוגיות - מיערות גשם טרופיים ועד חופי אגם מקומי. הפארק נמצא כ - 60 קילומטר מערבית להואה הין, נמשך עד לגבול תאילנד - מיאנמר ולתוך מיאנמר עצמה.<br/>הפארק, הינו מרחב עשיר בבעלי חיים - הוא מהווה בית למגוון בעלי חיים ובכלל זה, פילים, נמרים, דובים, ציפורים, פרפרים וחיות טרופיות נוספות.<br/>טיולי ג'יפים וטבע - ישנם סיורי ג'יפים מודרכים ברחבי הפארק, המאפשרים לצפות בבעלי חיים ובנופים הפראיים של הפארק. ישנם גם מסלולי הליכה לשמורות המים, בהם ניתן למצוא בריכות טבעיות ונהרות.",
        },
        {
          subtitle: 'הפארק הלאומי Kui Buri',
          text: 'הפארק הלאומי Kui Buri נמצא כ - 80 קילומטרים דרומית להואה הין והינו אחד המקומות הטובים ביותר בתאילנד לצפייה בפילים ובעלי חיים אחרים בטבע. הוא נחשב לשמורת טבע מיוחדת, בה ניתן לראות בעלי חיים כגון פילים, צבאים, איילים ועוד, בסביבתם הטבעית.<br/>טיולי ספארי - ישנם סיורי ספארי מודרכים בפארק, בהם תוכל לצפות בפילים ובבעלי חיים נוספים בעונה היבשה (דצמבר עד אפריל), כשהינם מתרכזים באזורי המים שבפארק.<br/>תצפיות טבע - הפארק מציע תצפיות פנורמיות מרהיבות על אזור החיות השונות וההרים שמסביב.',
        },
        {
          subtitle: 'פארק סיקאדה (Cicada Park)',
          text: 'הרחבה הירוקה הצמודה לשוק סיקאדה מהווה מקום נעים למנוחה, טיול רגלי קצר או פיקניק. יש בה שבילים מוצלים, מדשאות, פסלים מודרניים ולעיתים גם מופעי מוזיקה חיה או דוכני אוכל באירועים מיוחדים.<br/><strong>מיקום:</strong> סמוך לשוק Cicada, בשכונת קאו טאקיאב',
        },
        {
          subtitle: 'Khao Hin Lek Fai - גבעת התצפית',
          text: 'גבעה נמוכה המציעה את אחת מנקודות התצפית היפות ביותר על העיר והים. מסלול קצר של עלייה מוביל למרפסת עץ עם תצפית פנורמית על הואה הין, דגש על שעות הבוקר או לקראת שקיעה. זהו גם מקום פופולרי בקרב מקומיים לפיקניקים קצרים, עם מספר שבילים קטנים ומרפסות נוספות.<br/><strong>שעות פתיחה:</strong> 06:00 עד 19:00<br/><strong>טיפ:</strong> ניתן לראות קופים באזור - הקפידו לא להאכיל ולא להשאיר חפצים ללא שמירה.',
        },
        {
          subtitle: 'האי Ko Talu',
          text: 'אי הנמצא במרחק של כשעתיים נסיעה דרומית להואה הין וכ - 30 דקות שייט מהחוף והינו מקום מושלם למחפשים חוויות טבעיות ושקטות. האי ידוע בזכות חופי החול הלבן והמים הצלולים.<br/>שנורקלינג וצלילה - האי מציע חוויות שנורקלינג וצלילה במים עמוקים, שם ניתן לצפות בדגים טרופיים ושוניות אלמוגים.<br/>טיולים רגליים באי - ישנם מסלולי הליכה קלים על האי, שיביאו אתכם לנופים מרהיבים של החוף והים.',
        },
      ],
    },
    {
      title: 'מוזיאונים ואתרי תרבות',
      type: 'sub-headers',
      description:
        'הואה הין מציעה מגוון אתרי תרבות והיסטוריה המשקפים את העושר התרבותי של תאילנד ואת ההיסטוריה המלכותית של העיר.',
      content: [
        {
          subtitle: 'Wat Huay Mongkol',
          text: 'אתר המציע מבט ייחודי על התרבות הבודהיסטית המקומית. המדובר, במתחם מקדשים בודהיסטי המשמש כביתו של הפסל הגדול בעולם של Luang Phor Thuad, נזיר דרום תאילנדי מפורסם ונערץ מאוד, אשר כתוצאת הארתו ויכולתו לבצע ניסים, רבים מבני העם התאילנדי מאמינים כי הקמעות אשר נוצרו בדמותו מסייעות בשעת מצוקה. הפסל, הממוקם בתוך קומפלקס דמוי פארק המושך מבקרים רבים, בעיקר תאילנדים ובעיקר בסופי שבוע ונמצא באזור Ban Huay Khot, כ-15 ק"מ מערבית להואה הין.<br/>פסלו של לואנג פו תואד ניצב על גבי תל גדול, בצורה מלכותית ועל רקע האופק, גובהו 12 מטרים ורוחבו 10 מטרים ומשקלו טונות רבות. מאסיביות זו של הפסל הינה בהתאמה לדמותו האגדית והגדולה מהחיים של לואנג פו תואד. הנזיר מפוסל במצב רגוע ושליו במרכז המקדש, מצב אשר אמור לשדר למאמינים בו כי בהביטם למעלה, ירגישו את ההילה מתפשטת אליהם ומשרה עליהם שלווה ורוגע.<br/>הפסל הוקם ביוזמת המלכה סיריקיט, מלכת תאילנד לשעבר ואלמנתו של המלך פומיפון אדוניאדט (ראמה התשיעי), אשר הן תחומי התרבות והאומנות, דגש על הקשרי הדת הבודהיסטית והן תושבי דרום תאילנד - מקום מושבו של הנזיר, היו קרובים לליבה.',
        },
        {
          subtitle: 'Wat Khao Takiab',
          text: 'מקדש מרשים על ראש גבעה בדרום העיר. במתחם יש פסלי בודהה ענקיים, תצפית מרהיבה לים וקהילה של קופים חופשיים (יש להיזהר מהם). המקום רוחני ורגוע ומהווה אחד מהסמלים הבולטים של העיר. ניתן לעלות ברגל או ברכב והנוף מהפסגה בהחלט שווה את המאמץ.',
        },
        {
          subtitle: 'ארמון המלך ראמה ה - 6 (Mrigadayavan Palace)',
          text: 'ארמון הקיץ של המלך ראמה ה - 6 נמצא צפונית להואה הין, במרחק נסיעה קצר. הארמון בנוי כולו מעץ טיק בעיצוב אדריכלי תאילנדי - קולוניאלי, ניצב על עמודים ומוקף גנים טרופיים מטופחים. ביקור במקום מאפשר הצצה מרתקת לאורח החיים המלכותי בעבר ונחשב לאחד האתרים התרבותיים המרשימים באזור.',
        },
        {
          subtitle: 'Hua Hin Railway Station',
          text: 'אחת התחנות היפות ביותר בתאילנד, בעלת מבנה היסטורי בסגנון מלכותי תאילנדי. המקום פוטוגני מאוד ומספר את סיפורה של הואה הין כעיר נופש של האליטה. מומלץ לבקר בתחנה גם אם אינכם נוסעים ברכבת.',
        },
      ],
    },
    {
      title: 'חוויות קולינריות',
      type: 'sub-headers',
      description:
        'הואה הין מתאימה לחובבי קולינריה - תוכלו ליהנות בה מדוכני רחוב עם מנות תאילנדיות אותנטיות, לצד מסעדות שף וביסטרו מערביים. שוק הלילה הקבוע הינו מוקד קולינרי חי ותוסס, בו תמצאו מנות טריות, קינוחים אקזוטיים, ופירות ים מהים הסמוך. Tamarind Market, בסופי שבוע, מהווה שילוב בין שוק אוכל למסעדות פתוחות עם הופעות חיות.',
      content: [
        {
          subtitle: 'Chaolay Seafood Hua Hin',
          text: 'כמו רוב הערים החופיות בתאילנד, בהואה הין תוכלו למצוא מסעדות דגים ופירות ים איכותיות. "Chaolay" מציעה דגים ופירות ים טריים כגון לובסטרים, סרדינים, פירות ים נרקבים, טונה ועוד. המיקום הצמוד לחוף הופך את הארוחה לייחודית, הכוללת נופים של הים.',
        },
        {
          subtitle: 'Baan Itsara',
          text: 'נחשבת למסעדת פירות הים הטובה בעיר, ממוקמת מול הים, עם תפריט עשיר ומיקום רומנטי.',
        },
        {
          subtitle: 'Coast Beach Club',
          text: 'אופציה יוקרתית ויקרה יותר של מסעדת פירות ים איכותית, ממוקמת במתחם מלון Centara Grand Beach Resort & Villas Hua Hin',
        },
        {
          subtitle: 'Olivier',
          text: 'מסעדת "אוליביה", הממוקמת במרכז העיר, הינה אחת מהמסעדות הצרפתיות הבולטות בעיר, בה מגישים מנות איכותיות של בשרים, דגים ורטבים מיוחדים. מתאים במיוחד לארוחה רומנטית ו/ או לארוחה עם חברים ובני משפחה.',
        },
        {
          subtitle: 'The Coffee Club',
          text: 'אם הינכם מחפשים מקום המציע מנות בינלאומיות משובחות לארוחות בוקר, "The Coffee Club" הינו המקום עבורכם. המקום מציע ארוחות בוקר מושלמות - חביתות שונות, לחם מיוחד, כריכים מגוונים ואף קפה משובח.',
        },
      ],
    },
    {
      title: 'חיי לילה בהואה הין',
      type: 'sub-headers',
      description:
        'הואה הין מציעה חיי לילה שקטים יותר ביחס לערים אחרות בתאילנד, אך עדיין ישנם הרבה מקומות בהם אפשר להנות ולהעביר ערב כיף. העיר מושכת מבקרים מכל העולם, במיוחד את אלו המחפשים חוויה רגועה ומפנקת יותר אחרי יום ארוך של טיולים.',
      content: [
        {
          subtitle: 'Soi Bintabaht',
          text: 'הינו ה - Walking Street של הואה הין. ברחוב זה וברחובות הסמוכים אליו תמצאו ברים, פאבים ומועדונים אך, כאמור, מדובר בסביבה הרבה פחות רועשת מאשר בערים אחרות בתאילנד.',
        },
        {
          subtitle: 'Cicada Market ו - Tamarind Market',
          text: 'בשעות הערב, שווקים אלו, הפעילים בסופי שבוע, הופכים למוקד של מסעדות, דוכני אוכל רחוב ומוזיקה חיה. אלו מקומות נהדרים לבלות בהם ערב עם משפחה או חברים.',
        },
        {
          subtitle: 'The Rooftop Bar by Hilton Hua Hin Resort & Spa',
          text: 'בר יוקרתי, הממוקם במלון הילטון, אידיאלי למחפשים חוויה יוקרתית הכוללת שירות ברמה גבוהה.',
        },
        {
          subtitle: 'Hi4 Pub',
          text: 'בר מקומי פופולרי עם להקות חיות, תפריט מגוון של משקאות ואווירה תוססת עם קהל מעורב של מקומיים ותיירים. המקום פתוח עד השעות המאוחרות של הלילה ומהווה אחד המוקדים הפעילים של חיי הלילה בעיר.',
        },
        {
          subtitle: 'Oceanside Beach Club',
          text: 'בר ומסעדה על שפת הים, המציעים חוויה רומנטית במיוחד - תאורה רכה, בריכה, מוזיקת רקע ונוף לגלים. אידיאלי לזוגות או לקבוצות שמחפשות בילוי יוקרתי ונינוח יותר בערב.',
        },
      ],
    },
    {
      title: 'פסטיבלים, הופעות חיות ואירועים',
      type: 'sub-headers',
      description:
        'במהלך השנה מתקיימים בעיר פסטיבלים מוזיקליים, פסטיבלים קולינריים, תערוכות אמנות ואירועים דתיים. אלו מעניקים למבקרים טעימה מיוחדת מהתרבות התאילנדית ככלל והמקומית כפרט.',
      content: [
        {
          subtitle: 'Hua Hin International Jazz Festival',
          text: "אחד הפסטיבלים המובילים והאהובים בעיר, מתקיים בדרך כלל בחודשים מאי - יוני, על חוף הים של העיר ובו מתקיימות הופעות חיות בסופי השבוע של אמני ג'ז מקומיים ובינלאומיים. מדובר בכארבעה ימים של מוזיקת ג'אז, תרבות ואירועים משולבים יצירתיים, המשלבים הופעות בחוף הים, אירועי גאלה, הופעות בתוך ארמונות ועוד. הכניסה לרוב חופשית, האווירה חמה ונעימה והמיקום הופך את הערב לחגיגה של מוזיקה מול הגלים.",
        },
        {
          subtitle:
            "Thailand International Kite Festival פסטיבל העפיפונים הבינלאומי של תאילנד (צ'ה-אם)",
          text: "פסטיבל צבעוני ומשמח, המתקיים בחודש מרץ בעיירה צ'ה אם הסמוכה להואה הין. במהלך הפסטיבל, מוצגים מאות עפיפונים צבעוניים המופרחים לשמיים, כולל עפיפונים בצורת חיות ענק, מופעי תעופה, תחרויות ועפיפונים מוארים בלילה. הפסטיבל מציע גם פעילויות נוספות כגון סדנאות יצירה והופעות חיות ומתאים מאוד למשפחות.",
        },
        {
          subtitle: 'Hua Hin Food Festival',
          text: 'פסטיבל קולינרי ססגוני, המציג את מיטב המטבח התאילנדי המקומי - מדוכני רחוב ועד מסעדות גורמה. מתקיים בדרך כלל בחודש דצמבר, על הטיילת וכולל מופעי שף, טעימות, הופעות חיות ודוכני אוכל מכל רחבי האזור.',
        },
        {
          subtitle: 'Hua Hin Regatta',
          text: 'תחרות שיט מפרשים בינלאומית, הנערכת מול חופי הואה הין, בדרך כלל בחודש אוגוסט. האירוע מושך שייטים מקצועיים וחובבים כאחד ומתקיים באווירה ספורטיבית וחגיגית. חווייה יפה לצפייה מהחוף.',
        },
        {
          subtitle: 'Wine & Dine Events',
          text: 'בעיר ישנם לא מעט אירועים המשלבים אוכל ויין, במיוחד בעונות החגים והחום.',
        },
      ],
    },
    {
      title: 'ספא ומרכזי בריאות בהואה הין',
      type: 'sub-headers',
      description:
        "שפע של מכוני מסאז' תמצאו ברחבי הואה הין ואלו מציעים חבילות מרגיעות במחירים נוחים. בתי מלון רבים כוללים אף מרכזי ספא עם טיפולים יוקרתיים. מומלץ במיוחד לנסות מסאז' תאילנדי מסורתי או עיסוי שמנים חמים. ישנם אף מרכזי בריאות בעיר המתמחים בטיפולי רפואה סינית, דיקור סיני ועיסויים תאילנדיים מיוחדים.",
      content: [
        {
          subtitle: 'Spa at Hua Hin Marriott Resort & Spa',
          text: 'זהו אחד ממרכזי הספא המובילים בעיר, המציע מגוון טיפולים, רוגע וטיפולי יופי.',
        },
        {
          subtitle: 'The Barai Spa',
          text: 'ספא יוקרתי במתחם מלון היוקרה Hyatt Regency, עם עיצוב גאומטרי דרמטי, המעניק תחושת רוגע מוחלטת. מציע מגוון טיפולים הוליסטיים ובכלל זה, עיסויים טיפוליים, טיפולי גוף, טיפול בצלילים ורייקי. חוויה מושלמת למחפשים פינוק ברמה גבוהה.',
        },
        {
          subtitle: 'Chiva-Som Hua Hin Wellness Resort',
          text: 'אחד ממרכזי הבריאות היוקרתיים ביותר באסיה ובעולם. מתמחה בריפוי הוליסטי, דיאטות, טיפולים אישיים, יוגה, מדיטציה, תזונה מותאמת אישית ועוד. מיועד לאורחים המעוניינים בשינוי עמוק באורח חייהם.',
        },
        {
          subtitle: "Let's Relax Spa",
          text: "רשת ספא ​​ידועה בתאילנד המציעה חבילות מסאז' איכות גבוהה במחירים סבירים. ניתן למצוא סניפים באזורים מרכזיים של העיר, המציעים טיפולי שמן, עיסוי תאילנדי טבעי, מסכות פנים ועוד.",
        },
        {
          subtitle: 'Oasis Spa',
          text: 'ספא בוטיק עטוף בצמחייה טרופית, באווירה רגועה במיוחד. התפריט כולל מגוון רחב של טיפולים מרגיעים, עם שימוש במרכיבים טבעיים ושמנים ארומטיים. מתאים לזוגות או מטיילים המחפשים ניתוק מוחלט.',
        },
      ],
    },
    {
      title: 'חוויות ופעילויות משפחתיות נוספות',
      type: 'sub-headers',
      description:
        'הואה הינה עיר ידידותית מאוד למשפחות, עם שפע של פעילויות המיועדות לילדים ולמבוגרים כאחד. פארקי מים, רכיבה על סוסים, שווקים צבעוניים ופעילויות בטבע ועם בעלי חיים - הופכים את הואה הין ליעד אהוב על משפחות. אתרים כמו Swiss Sheep Farm או Camel Republic משלבים חיות משק, משחקים ואטרקציות חינוכיות.',
      content: [
        {
          subtitle: 'Vana Nava Water Jungle - חוויה טרופית לכל המשפחה',
          text: 'פארק מים טרופי מהגדולים והמתקדמים בתאילנד, הממוקם דרומית למרכז העיר. הפארק בנוי כג\'ונגל טרופי, משולבים בו עצים טבעיים, מפלים, מגלשות מים מרהיבות ומתקנים מהמתקדמים בעולם, כולל מגלשות ענקיות, בריכת גלים, נהר אבובים, אזור משחקים לילדים ו"אזור יבש" עם קירות טיפוס ואומגה. במקום גם מסעדות, לוקרים, ומקלחות מודרניות.<br/>מתאים למשפחות עם ילדים, זוגות, קבוצות - כלל הגילאים<br/><strong>מיקום:</strong> ליד מלון Holiday Inn Vana Nava, כ - 10 דקות נסיעה ממרכז הוא הין<br/><strong>שעות פתיחה:</strong> כל יום, 11:00 - 17:00<br/><strong>אתר רשמי:</strong> https://www.vananavahuahin.com',
        },
        {
          subtitle: 'Black Mountain Water Park - פארק מים רגוע למשפחות',
          text: 'פארק מים נוסף, קטן יותר מ-Vana Nava אך שקט, מרווח ופחות עמוס. ממוקם צפונית מערבית למרכז העיר, בסמוך לשכונת המגורים Black Mountain ולמסלול הגולף המפורסם. כולל מספר בריכות, מגלשות מים באורכים שונים, נהר אבובים, בריכת גלים גדולה, אזור צל לשהייה רגועה, ומסעדה צמודה. מתאים במיוחד למשפחות המחפשות בילוי רגוע, פחות מסחרי ופחות המוני.<br/><strong>מיקום:</strong> כ - 15 דקות נסיעה צפונית מערבית למרכז העיר, באזור ההר השחור (Black Mountain)<br/><strong>שעות פתיחה:</strong> כל יום, 11:00 - 17:00<br/><strong>אתר רשמי:</strong> http://www.blackmountainwaterpark.com',
        },
        {
          subtitle:
            'Hua Hin Safari & Adventure Park - ספארי ומפגש עם בעלי חיים',
          text: 'פארק גדול, בו ניתן לפגוש מקרוב פילים, טיגריסים, קופים, נחשים ועוד, להצטלם עימם ולהשתתף בחוויית האכלתם ורחיצתם. האתר אף מציע מופעים של תנינים, פילים, נמרים ונחשים, אפשרות לרכיבה על פילים, צפייה בגידולם ועוד. חוויה ייחודית למשפחות עם ילדים, המעוניינים לטעום חוויית ספארי פשוטה במאפיין של טיול יום בטבע. באתר אף קיימים אזור קמפינג ואזור מסעדות.<br/><strong>מיקום:</strong> כ-15 דקות נסיעה דרומה ממרכז העיר, בדרך לחופי Khao Takiab<br/><strong>שעות פתיחה:</strong> כל יום, 09:00 - 17:00<br/>מתאים למשפחות, בעיקר עם ילדים צעירים<br/>כניסה בתשלום, חלק מהפעילויות דרושות תשלום נוסף.',
        },
      ],
    },
    {
      title: 'חוויות רומנטיות',
      type: 'sub-headers',
      description:
        'העיר אידיאלית לזוגות - החל מהליכות לאורך החוף, דרך טיפולי ספא זוגיים, ועד לארוחות ערב רומנטיות מול השקיעה. זוגות רבים בוחרים בהואה הין כיעד לירח דבש רגוע ויוקרתי.',
      content: [
        {
          subtitle: 'שייט פרטי בשקיעה לאורך חופי הואה הין',
          text: 'חוויה רומנטית בלתי נשכחת - הפלגה בסירה פרטית לאורך החוף, כאשר השמש שוקעת על פני המים. ניתן לשלב עם בקבוק יין או ארוחה קלה.',
        },
        {
          subtitle: 'ארוחת ערב רומנטית במסעדות עם נוף לים',
          text: "La Mer - מסעדת שף עם תפריט פיוז'ן מול הים.<br/>Vana Nava Sky Bar & Restaurant - מסעדת גג עם נוף פנורמי, תאורה רכה וקוקטיילים מיוחדים.",
        },
        {
          subtitle: 'טיול אופניים זוגי לאורך החוף או בכפרים',
          text: 'השכרת אופניים ורכיבה לאורך הטיילת או בכפרים שמסביב לעיר הינה דרך נהדרת לחוות את האזור באיטיות ובשקט. אפשר גם לשלב עם פיקניק בחוף.',
        },
        {
          subtitle: "ביקור רומנטי בצ'ה - אם Cha Am",
          text: "האווירה המקומית האותנטית של העיירה צ'ה - אם מציעה זוגיות שקטה - מסעדות קטנות ודגים טריים ליד החוף, ריחות מקומיים ושקיעות קסומות.",
        },
        {
          subtitle: 'סיור כרכרות סוסים בעיר העתיקה',
          text: 'חוויה נוסטלגית המתאימה לזוגות המחפשים חוויה מיוחדת ורגועה בעיר. הסיורים מתקיימים בעיקר באזורים הוותיקים של העיר.',
        },
        {
          subtitle: 'ביקור בשוק הצף Sam Phan Nam Floating Market',
          text: 'שוק צף באווירה תאית מסורתית, הממוקם כ - 15 דקות נסיעה ממרכז העיר ובו סירות קטנות, מופעי פולקלור, דוכני אוכל ומתנות. מתאים לזוגות האוהבים לשוטט בין דוכנים באווירה אותנטית.',
        },
      ],
    },
    {
      title: 'אתרים מיוחדים נוספים',
      type: 'sub-headers',
      description:
        'הואה הין מציעה מגוון אתרים נוספים וייחודיים המשלבים אמנות, היסטוריה ותרבות מקומית, המספקים חוויות מגוונות למטיילים המעוניינים לחקור מעבר לחופים ולשווקים.',
      content: [
        {
          subtitle: 'Baan Sillapin (Hua Hin Artist Village) - כפר האמנים',
          text: 'כפר אמנים של ממש, המציע שילוב של גלריות, סטודיו, חנויות אמנות ובתי קפה באווירה שקטה וכפרית. המקום מארח אמנים מקומיים מצטיינים ומציע גם סדנאות אמנות, ציור, פיסול ועוד - מה שהופך אותו לאידיאלי למשפחות עם ילדים, זוגות, או חובבי אמנות. דרך נהדרת לחוות את הצד היצירתי של הואה הין.',
        },
        {
          subtitle: 'Rajabhakti Park - פארק המלכים',
          text: 'פארק מרשים ומהודר, אשר בו ניצבים פסלים מונומנטליים של שבעה ממלכי תאילנד הגדולים מהעבר, כל אחד בגובה של כ - 14 מטרים. הפארק שוכן למרגלות ההרים, מוקף במדשאות מטופחות ובאווירה מכובדת. זוהי אטרקציה עם ערך היסטורי לאומי ומומלץ להגיע אליה בשעות הבוקר או אחה"צ כדי להימנע מהחום.',
        },
      ],
    },
    {
      title: "העיירה Cha-Am (צ'ה אם)",
      type: 'sub-headers',
      description:
        'כ - 25 ק"מ צפונית להואה הין, נמצאת עיירת חוף שקטה ופחות מתויירת מהואה הין, Cha Am שמה. הביקור במקום מתאים בעיקר כטיול יום רגוע או אף ללינה של לילה - שניים באווירה כפרית יותר. צ\'ה אם מציעה חופים נקיים וארוכים, מקומיים חביבים ומחירים זולים יותר לעומת אתרי הנופש הפופולריים.',
      content: [
        {
          subtitle: "אטרקציות בולטות בצ'ה אם",
          text: "<strong>Cha-Am Beach</strong> - חוף ים ארוך ורחב עם כיסאות חוף, דוכני אוכל מקומי ואפשרות לשכור אופניים לאורך הטיילת.<br/><strong>Swiss Sheep Farm</strong> - חווה בנוסח שווייצרי עם כבשים, סוסים, ואטרקציות לילדים, כמו האכלת חיות ורכיבה על סוסים קטנים.<br/><strong>Camel Republic</strong> - פארק חיות ואטרקציות בסגנון מרוקאי עם גמלים, ציפורים ופארק שעשועים קטן לילדים.<br/><strong>Santorini Park Cha-Am</strong> - מתחם קניות ובילוי בעיצוב יווני, כולל חנויות בוטיק, מתקני שעשועים, גלגל ענק ואזורי צילום מיוחדים.<br/><strong>Mrigadayavan Palace</strong> - ארמון עץ עתיק שבנה המלך ראמה השישי כמעון קיץ. ממוקם בין הואה הין לצ'ה אם ומומלץ מאוד למבקרים המתעניינים בהיסטוריה ובאדריכלות תאילנדית.",
        },
        {
          subtitle: "איך מגיעים לצ'ה אם?",
          text: "<strong>רכב פרטי או מונית</strong> - הדרך הנוחה והמהירה ביותר (כ-25 דקות).<br/><strong>מיניבוסים מקומיים</strong> - יוצאים בתדירות גבוהה ממרכז הואה הין.<br/><br/>צ'ה אם מתאימה במיוחד למעוניינים ביום רגוע של חופים, אוכל מקומי ואווירה אותנטית וניתן לשלב אותה בטיול יום מלא או כחלק מנסיעה מהואה הין לבנגקוק או לפאטצ'ואפ קירי קאן.",
        },
      ],
    },
    {
      title: 'טיפים חשובים למטיילים',
      type: 'list',
      description:
        'כדי להפיק את המרב מהביקור בהואה הין ובסביבתה, הנה מספר טיפים חשובים שיעזרו לכם לתכנן את הטיול בצורה הטובה ביותר:',
      content: [
        'רכב שכור הינו הדרך הטובה ביותר לטייל באזור, דגש אם בכוונתכם לטייל באזורים המרוחקים מהעיר.',
        'נסיעה בטוק-טוק או מוניות אופנוע בתוך העיר, הינה זולה ונוחה - אך מומלץ לסכם מחיר מראש.',
        'הימנעו ממגע ישיר עם הקופים באזור הר Khao Takiab, דגש על הימנעות מהאכלתם.',
        'הצטיידו בכובע, מים וקרם הגנה - גם בעונה היבשה השמש חזקה.',
        'התחילו את הערב בשווקים המקומיים, שם תמצאו אוכל מעולה ואווירה נהדרת במחיר משתלם ובקרו בהם בשעות הערב המוקדמות, קודם שהמקום מתמלא.',
        'בקרו באתרים בשעות הבוקר כדי להימנע מהחום.',
        "אם הינכם שוהים מספר ימים בהואה הין, מומלץ להקדיש יום נפרד לצ'ה אם - לשילוב של טבע, תרבות, ים ושקט מקומי. מומלץ במיוחד בסופי שבוע, כשבמקום ישנה אווירה תוססת מחד אך לא עמוסה מדי מאידך.",
        'הזמינו לינה מראש לסופ"ש וחגים, במיוחד בקרבת החוף, שכן זהו יעד מועדף גם על מקומיים.',
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      description: '',
      content:
        'הואה הין הינה יעד מושלם למחפשים חופשה רגועה, בטוחה ונוחה על חוף הים בתאילנד, עם שילוב של נופים מרהיבים, חופים נקיים, שווקים צבעוניים, תרבות מקומית עשירה ונגישות גבוהה לבנגקוק. בין אם הינכם משפחה עם ילדים, זוג בירח דבש או מטיילים עצמאיים - תמצאו כאן כל מה שתצטרכו: חופים אידיאליים לרחצה, מקומות לינה מגוונים, אוכל נהדר, קניות ואטרקציות רבות.<br/><br/>מומלץ מאוד להקדיש להואה הין לפחות 3 - 4 לילות ולשלב אותה כחלק מטיול רחב יותר בדרום תאילנד או בטיול המשולב עם בנגקוק והמרכז. השילוב בין אווירה מקומית תאית לבין נוחות מערבית הופך את העיר לאחד מהיעדים הנעימים והמפתיעים ביותר בתאילנד.',
    },
  ],
};
